<template>
  <v-card>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="serialNumSearch"
        append-icon="search"
        label="Номер счетчика"
        single-line
        hide-details
      />
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="availableCountersHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        @click:row="selected"
        no-data-text="Нет данных для отображения"
        :footer-props="{
          itemsPerPageText: 'Число счетчиков на странице',
          itemsPerPageOptions: [25, 50]
        }"
        dense
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PointCounterInstallExisted',
  props: [
    'modelId'
  ],
  data () {
    return {
      firstLoading: true,
      loading: false,
      serialNumSearch: '',
      counter: {},
      items: [],
      serverItemsLength: 0,
      options: {},
      availableCountersHeaders: [
        {
          text: 'Серийный номер',
          align: 'left',
          sortable: false,
          value: 'serial_num'
        },
        {
          text: 'Модель',
          align: 'left',
          sortable: false,
          value: 'model.name'
        },
        {
          text: 'Коэф.трансформации тока',
          align: 'left',
          sortable: false,
          value: 'coeff'
        },
        {
          text: 'Коэф.трансформации напряжения',
          align: 'left',
          sortable: false,
          value: 'coeff_voltage'
        }
      ],
      getTimer: '',
      searchTimer: ''
    }
  },
  watch: {
    modelId (val) {
      if (val) {
        this.getCountersApiTimer()
      }
    },
    options: {
      handler () {
        this.getCountersApiTimer()
      },
      deep: true
    },
    serialNumSearch () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.options.page = 1
        this.getCountersApiTimer()
      }, 500)
    }
  },
  methods: {
    selected (item) {
      this.$emit('selected', item)
    },
    getCountersApi () {
      this.loading = true
      this.axios.get(
        `/api/counters/available_for_install/` +
        `?per_page=${this.options.itemsPerPage}` +
        `&page=${this.options.page}` +
        `&search=${this.serialNumSearch}` +
        `&model_id=${this.modelId}`
      )
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.firstLoading = false
          this.loading = false
        })
    },
    getCountersApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getCountersApi()
      }, 100)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/spa/points/counters/PointCounterInstallExisted.vue